import { render } from "./SetOneGet.vue?vue&type=template&id=a5d81d52&scoped=true"
import script from "./SetOneGet.vue?vue&type=script&lang=js"
export * from "./SetOneGet.vue?vue&type=script&lang=js"

import "./SetOneGet.vue?vue&type=style&index=0&id=a5d81d52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d81d52"]])

export default __exports__